import en from './en.json'
import th from './th.json'
import cn from './cn.json'

export const defaultLocale = 'th'

export const languages = {
  en: en,
  th: th,
  cn: cn
}


// WEBPACK FOOTER //
// ./src/plugins/lang.js